// extracted by mini-css-extract-plugin
export default {"warningColor":"#ef6c00","successColor":"#4caf50","errorColor":"#eb4d4d","grayColor":"#8D8D8D","placeHolderShimmer":"statusColor_placeHolderShimmer__Fc6dA"};